<header [class.bg-dark]="headerStyle === HeaderStyleEnum.Support"
        [class.default]="headerStyle === HeaderStyleEnum.Default"
        [class.homepage]="headerStyle === HeaderStyleEnum.HomePage"
        [class.support]="headerStyle === HeaderStyleEnum.Support"
>
  <div [class.d-flex]="showLanguageSwitcherBar"
       class="bg-dark text-center text-white pt-2 pb-2 d-none"
       id="language-switcher-bar"
       style="margin-left: -15px; margin-right: -15px;">
    @if (localeManager.getCurrentLocale() === LocaleEnum.French) {
      <div class="align-self-center" style="margin-left: calc(50% - 90px)">
        View this site in <a [routerLink]="this.routeManager.getCurrentRouteInLocale(LocaleEnum.English)"
                             class="btn btn-primary btn-sm ms-2">English</a>
      </div>

      <div>
        <button class="btn btn-link ms-3" (click)="doNotShowLanguageSwitcherBar()">Do not show this again
        </button>
      </div>
    } @else if (localeManager.getCurrentLocale() === LocaleEnum.English) {
      <div class="align-self-center" style="margin-left: calc(50% - 90px)">
        Consulter ce site en <a [routerLink]="this.routeManager.getCurrentRouteInLocale(LocaleEnum.English)"
                                class="btn btn-primary btn-sm ms-2">Français</a>
      </div>

      <div>
        <button class="btn btn-link ms-3" (click)="doNotShowLanguageSwitcherBar()">Ne plus jamais montrer
        </button>
      </div>
    }
  </div>

  <div class="container">
    <nav [class.collapsed]="this.collapsed" id="main-navbar">
      <div class="brand">
        <!--                <a href="{{ path("index") }}">-->
        <!--                {{ component('image', {-->
        <!--                size: 300,-->
        <!--                url: "assets/images/logos/logo-white.png",-->
        <!--                fetchPriority: "high",-->
        <!--                loading: "eager",-->
        <!--            }) }}-->
        <!--                </a>-->
        <a routerLink="/">
          <app-image [fetchPriority]="FetchPriorityEnum.High"
                     [loading]="LoadingEnum.Eager"
                     [url]="'images/logos/logo-white.png'"
          ></app-image>
        </a>
      </div>

      <ul class="main-links">
        <li>
          <a [routerLink]="routeManager.getRouteInCurrentLocale(RouteEnum.Calculations)">{{ HeaderContentResources["header.main.calculations"] | render | async }}</a>
        </li>
        <li>
          <a [routerLink]="routeManager.getRouteInCurrentLocale(RouteEnum.Pricing)">{{ HeaderContentResources["header.main.pricing"] | render | async }}</a>
        </li>
        <li>
          <a [routerLink]="routeManager.getRouteInCurrentLocale(RouteEnum.ContactUs)">{{ HeaderContentResources['header.main.contact-us'] | render | async }}</a>
        </li>
      </ul>

      <ul>
        <li><a class="btn btn-primary"
               href="https://app.optitax.ca">{{ HeaderContentResources['header.main.login'] | render | async }}</a>
        </li>
        <li class="ms-2 me-1"><a class="btn btn-link text-white"
                                 href="https://client.optitax.ca">{{ HeaderContentResources['header.main.client-portal'] | render | async }}</a>
        </li>
        @if (localeManager.getCurrentLocale() === LocaleEnum.French) {
          <li><a [routerLink]="this.routeManager.getCurrentRouteInLocale(LocaleEnum.English)"
                 class="btn btn-link text-white" style="font-size: 0.8rem; margin-top: 3px;">English</a></li>
        } @else if (localeManager.getCurrentLocale() === LocaleEnum.English) {
          <li><a [routerLink]="this.routeManager.getCurrentRouteInLocale(LocaleEnum.French)"
                 class="btn btn-link text-white" style="font-size: 0.8rem; margin-top: 3px;">Français</a></li>
        }
      </ul>
      <a (click)="toggleCollapsed()" class="menu-toggler" href="#">
        <i class="bi bi-list"></i></a>
    </nav>

    <div class="hero">
      <ng-content></ng-content>
    </div>
  </div>
</header>
